import {Brand, useGoogleInfo, useUpdateFeature} from "@mytour/platform";
import type {UpdateFeaturePayload} from "@mytour/shared";
import {Trans as Translate, useTranslation} from "react-i18next";
import {useLocation} from "react-router";
import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

export const GoogleModal = () => {
  const {googleInfo} = useGoogleInfo();
  const {t: translate} = useTranslation();
  const location = useLocation();
  const {updateFeature} = useUpdateFeature();

  const googleError = new URLSearchParams(location.search).get("error");

  const Link = (props2: any) => <a href={props2.to} {...props2} />;
  return (
    <Modal isOpen={true} backdrop="static" id="login-page" autoFocus={false} centered>
      <ModalHeader close={<></>} className="mytour-header">
        <Brand />
        <Translate i18nKey="google.title">Sign in</Translate>
      </ModalHeader>
      <ModalBody>
        {googleError && (
          <Alert color="danger">
            <strong>{translate(`google.error.${googleError}`)}</strong>
          </Alert>
        )}
        <p>
          <Translate i18nKey="google.description">You need a google account.</Translate>
        </p>
        <p>
          <Translate i18nKey="google.description2">
            <strong>You need a google account.</strong>
          </Translate>
        </p>
        <Alert color="info">
          <Translate i18nKey="google.agendaHint">
            On the Google screen, make sure you allow Agenda access.
          </Translate>
        </Alert>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onAbort} id="abort">
          Ne pas synchroniser
        </Button>
        <Button tag={Link} color="primary" to={googleInfo?.url} style={{float: "right"}}>
          <Translate i18nKey="google.button">Login</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
  async function onAbort() {
    const entity: UpdateFeaturePayload = {
      synchronizeAgenda: false,
    };
    await updateFeature(entity);
  }
};
